/* ============================================================
   pdp.js — wires the product-page buy-box enhancements.
   Reads a per-variant JSON map emitted by pdp-value.liquid
   (all prices pre-formatted in Liquid → no JS money math) and:
     1. swaps per-soft-gel / one-time / subscribe prices on variant change
     2. toggles the One-time vs Subscribe & Save selection and the
        hidden `selling_plan` input that rides the native Dawn form.
   Resilient to Dawn's partial section re-render on variant change.
   ============================================================ */
(function () {
  function init(holder) {
    var cfg;
    try {
      cfg = JSON.parse(holder.textContent);
    } catch (e) {
      return;
    }
    if (holder.dataset.pdpReady === "1") return;
    holder.dataset.pdpReady = "1";

    var formId = holder.getAttribute("data-pdp-data");
    var form = document.getElementById(formId);
    var scope =
      (form && form.closest("product-info, .product, .product__info-container")) ||
      document;
    var hiddenId = form ? form.querySelector('input[name="id"]') : null;
    var planInput = scope.querySelector("[data-pdp-selling-plan]");
    var ids = Object.keys(cfg.variants);

    function currentId() {
      if (hiddenId && hiddenId.value) return String(hiddenId.value);
      try {
        var u = new URL(window.location.href).searchParams.get("variant");
        if (u && cfg.variants[u]) return u;
      } catch (e) {}
      return ids[0];
    }

    function update() {
      var v = cfg.variants[currentId()];
      if (!v) return;
      scope.querySelectorAll("[data-pdp-per-softgel]").forEach(function (el) {
        el.textContent = v.perSoftgel;
      });
      scope.querySelectorAll("[data-pdp-sub-price]").forEach(function (el) {
        el.textContent = v.subPrice;
      });
      scope.querySelectorAll("[data-pdp-onetime-price]").forEach(function (el) {
        el.textContent = v.price;
      });
    }

    function togglePlan() {
      var sub = scope.querySelector('[data-pdp-opt-input][value="subscribe"]');
      var isSub = !!(sub && sub.checked);
      scope.querySelectorAll("[data-pdp-opt]").forEach(function (card) {
        card.classList.toggle(
          "is-active",
          card.getAttribute("data-pdp-opt") === (isSub ? "subscribe" : "onetime")
        );
      });
      if (planInput) {
        if (isSub) {
          planInput.disabled = false;
          planInput.value = cfg.sellingPlanId;
        } else {
          planInput.disabled = true;
          planInput.value = "";
        }
      }
    }

    // Variant changes: Dawn dispatches `change` on the hidden id input.
    if (hiddenId) hiddenId.addEventListener("change", update);
    // Fallback: catch picker changes, read the (by-then) updated id after a tick.
    var vs = cfg.sectionId
      ? document.getElementById("variant-selects-" + cfg.sectionId)
      : null;
    if (vs) vs.addEventListener("change", function () { setTimeout(update, 60); });

    // Purchase-type toggle (immediate, no async).
    scope.addEventListener("change", function (e) {
      if (e.target && e.target.name === "purchase_type") togglePlan();
    });

    update();
    togglePlan();
  }

  function boot() {
    document.querySelectorAll("[data-pdp-data]").forEach(init);
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  // Re-bind if the theme editor reloads the section.
  document.addEventListener("shopify:section:load", boot);
})();
